import React, { useState, useEffect } from "react";
import { Star, ExternalLink } from "lucide-react";
import { API } from "@/lib/constants";

let cachedData = null;

const ReviewProofStrip = () => {
  const [data, setData] = useState(cachedData);
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (cachedData) return;
    fetch(`${API}/google-reviews/digital-media-ninja`)
      .then((r) => r.json())
      .then((d) => {
        if (d.reviews?.length) {
          cachedData = d;
          setData(d);
        }
      })
      .catch(() => {});
  }, []);

  const reviews = data?.reviews || [];

  useEffect(() => {
    if (reviews.length < 2) return;
    const t = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex((i) => (i + 1) % reviews.length);
        setVisible(true);
      }, 350);
    }, 7000);
    return () => clearInterval(t);
  }, [reviews.length]);

  if (!reviews.length) return null;

  const review = reviews[index];
  const info = data.place_info || {};

  return (
    <section className="py-12 bg-white/[0.03] border-y border-white/10" data-testid="review-proof-strip">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto text-center">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="flex gap-1">
              {[1, 2, 3, 4, 5].map((s) => (
                <Star key={s} className="w-5 h-5 fill-[#00E676] text-[#00E676]" />
              ))}
            </div>
            <span className="text-white font-semibold">{Number(info.rating || 5).toFixed(1)}</span>
            {info.total_reviews ? (
              <span className="text-gray-500 text-sm">· {info.total_reviews} Google reviews</span>
            ) : null}
          </div>
          <div
            className="transition-opacity duration-300 min-h-[88px] flex flex-col justify-center"
            style={{ opacity: visible ? 1 : 0 }}
            data-testid="review-proof-quote"
          >
            <p className="text-gray-300 italic text-lg leading-relaxed line-clamp-3">"{review.text}"</p>
            <p className="text-gray-500 text-sm mt-3">
              <span className="text-white font-medium">{review.author_name}</span>
              {review.relative_time_description ? ` · ${review.relative_time_description}` : ""} · Google review
            </p>
          </div>
          {info.google_url ? (
            <a
              href={info.google_url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-[#00E676] hover:text-[#00C853] text-sm mt-4 transition-colors"
              data-testid="review-proof-google-link"
            >
              See all reviews on Google <ExternalLink className="w-3.5 h-3.5" />
            </a>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default ReviewProofStrip;
